// extracted by mini-css-extract-plugin
module.exports = {"panelWrapper":"_2DmGS","lists":"_2tp74","backButton":"_2BE1E"};